import { FC, useEffect, useState } from 'react';
import { Image } from "@fluentui/react-components";
import './OpenAiLogo.scss';

export interface OpenAiLogoProps {
    theme?: 'light'  | 'dark';
    size?: 'small' | 'medium';
}

// renders the default GPT (SyGPT) logo in different ways
export const OpenAiLogo: FC<OpenAiLogoProps> = (props: OpenAiLogoProps) => {
    const height = props.size === 'small' ? 32 : 80;
    const width = props.size === 'small' ? 50 : 160;

    // Use CSS-controlled max sizes so the image remains responsive and cannot
    // overflow or be rendered oversized when layout changes. Avoid passing
    // height/width attributes to the Image component so the browser can scale
    // it down naturally.
    return (
        <div
            style={{ maxHeight: height, maxWidth: width }}
            className={`openai-logo-container ${props.size === 'small' ? 'small' : 'medium'}`}
        >
            <Image
                src={props?.theme === 'light' ? '\\SYGPT-Logo-Dark-BG.svg' : '\\SYGPT-Logo-Color.svg'}
                className="openai-logo-image"
                fit="contain"
                // don't pass height/width attributes here; CSS will constrain size
            />
        </div>
    );
};
